import KeyboardController from "./controller";

export default {
    __init__: ['keyboardController'],
    keyboardController: ['type', KeyboardController]
}